import * as yup from 'yup';

const getInTouchSchema = yup.object().shape({
  company: yup.string().required('Company Name is required'),
  name: yup.string().required('Name is required'),
  number: yup
    .string()
    .matches(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]{9,11}$/, 'Invalid number format')
    .required('Number is required'),
  email: yup.string().trim().email('Invalid email format').required('Email is required'),
  comments: yup.string().trim().required('Please enter some comments'),
});

export default getInTouchSchema;
